import { useEffect } from 'react'
import { useMouseEvents } from '~/hooks/useMouseEvents'
import { isInRange } from '~/utils/math'

export const useUserClickedOutsideElementBoundingBox = (
  element: HTMLElement | (HTMLElement | null)[] | null | undefined,
  onClickedOutsideBounds?: () => void,
) => {
  const mouseDownEvent = useMouseEvents()
  useEffect(() => {
    if (!element) return
    if (!(mouseDownEvent?.target instanceof Element)) return
    const isCollection = Array.isArray(element)
    const elements = isCollection ? element : [element]

    const extents = { left: 0, right: 0, top: 0, bottom: 0 }
    elements.forEach((el) => {
      if (!el) return

      const bounds = el.getBoundingClientRect()
      extents.left = Math.min(extents.left, bounds.left)
      extents.right = Math.max(extents.right, bounds.right)
      extents.top = Math.min(extents.top, bounds.top)
      extents.bottom = Math.max(extents.bottom, bounds.bottom)
    })

    const { clientX, clientY } = mouseDownEvent!

    const insideBounds =
      isInRange(clientX, extents.left, extents.right) &&
      isInRange(clientY, extents.top, extents.bottom)

    if (!insideBounds) {
      onClickedOutsideBounds?.()
    }
  }, [element, mouseDownEvent])
}
